module.exports = __webpack_public_path__ + "static/assets/avatars.c15191c6.png";